import { get, postJson, putJson, del } from '../httpClient';

export const audienceAPI = {
  // Lists
  getLists: () => get('/api/audience/lists'),
  createList: body => postJson('/api/audience/lists', body),
  getList: listId => get(`/api/audience/lists/${listId}`),
  updateList: (listId, body) => putJson(`/api/audience/lists/${listId}`, body),
  deleteList: listId => del(`/api/audience/lists/${listId}`),

  // Members
  addMember: (listId, body) => postJson(`/api/audience/lists/${listId}/members`, body),
  importMembers: (listId, body) => postJson(`/api/audience/lists/${listId}/import`, body),
  removeMember: memberId => del(`/api/audience/members/${memberId}`),

  // Legacy endpoints
  query: params => get('/api/audience/query', params),
  getImports: () => get('/api/audience/imports'),
  add: body => postJson('/api/audience/add', body),
  import: body => postJson('/api/audience/import', body),

  // Account matching
  matchSubscribers: () => postJson('/api/audience/match', {}),

  // Email campaigns
  getEmails: () => get('/api/audience/emails'),
  createEmail: body => postJson('/api/audience/emails', body),
  updateEmail: (id, body) => putJson(`/api/audience/emails/${id}`, body),
  deleteEmail: id => del(`/api/audience/emails/${id}`),
  sendEmail: id => postJson(`/api/audience/emails/${id}/send`, {}),
};
